<div class="page-breadcrumb">
        <div class="row">
            <div class="col-7 align-self-center">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Notifications</li>
                        </ol>
                    </nav>
                </div>
                <h4 class="page-title">Notifications</h4>
            </div>
       
        </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid" style="background-color: white">
        <ul class="list-style-none">
          
            <li>
                <div class="message-center notifications ps-container ps-theme-default" data-ps-id="089474f3-e06e-a3b1-d270-0ed11b6a5cac">
                    <!-- Message -->
                    <a href="javascript:void(0)" class="message-item">
                        <span class="btn btn-danger btn-circle">
                            <i class="fa fa-link"></i>
                        </span>
                        <div class="mail-contnet">
                            <h5 class="message-title">Luanch Admin</h5>
                            <span class="mail-desc">Just see the my new admin!</span>
                            <span class="time">9:30 AM</span>
                        </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="message-item">
                        <span class="btn btn-success btn-circle">
                            <i class="ti-calendar"></i>
                        </span>
                        <div class="mail-contnet">
                            <h5 class="message-title">Event today</h5>
                            <span class="mail-desc">Just a reminder that you have event</span>
                            <span class="time">9:10 AM</span>
                        </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="message-item">
                        <span class="btn btn-info btn-circle">
                            <i class="ti-settings"></i>
                        </span>
                        <div class="mail-contnet">
                            <h5 class="message-title">Settings</h5>
                            <span class="mail-desc">You can customize this template as you want</span>
                            <span class="time">9:08 AM</span>
                        </div>
                    </a>
                    <!-- Message -->
                    <a href="javascript:void(0)" class="message-item">
                        <span class="btn btn-primary btn-circle">
                            <i class="ti-user"></i>
                        </span>
                        <div class="mail-contnet">
                            <h5 class="message-title">Pavan kumar</h5>
                            <span class="mail-desc">Just see the my admin!</span>
                            <span class="time">9:02 AM</span>
                        </div>
                    </a>
                    <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;">
                        <div class="ps-scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                    </div>
                    <div class="ps-scrollbar-y-rail" style="top: 0px; right: 3px;">
                        <div class="ps-scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div>
                    </div>
                </div>
            </li>
            <li>
                <a class="nav-link text-center m-b-5 text-dark" href="javascript:void(0);">
                    <strong>Check all notifications</strong>
                    <i class="fa fa-angle-right"></i>
                </a>
            </li>
        </ul>
    </div>
